"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Angle = exports.AngleTexts = exports.AngleUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var AngleUnits;
(function (AngleUnits) {
    AngleUnits["default"] = "deg";
    AngleUnits["deg"] = "deg";
})(AngleUnits = exports.AngleUnits || (exports.AngleUnits = {}));
exports.AngleTexts = {
    [AngleUnits.default]: '°',
    [AngleUnits.deg]: '°',
};
class Angle extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'AngleAccessor';
        this.defaultUnit = 'deg';
        this.unitTexts = exports.AngleTexts;
    }
    static getUnitText(unit) {
        return exports.AngleTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(AngleUnits).includes(q.Unit)) {
            throw new Error(`Angle.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Angle(q);
    }
    static deg(v) {
        return new Angle({ Value: v, Unit: AngleUnits.deg });
    }
    set deg(v) {
        this.setValueUnit(v, AngleUnits.deg);
    }
    get deg() {
        switch (this.quantity.Unit) {
            case AngleUnits.deg:
                return this.quantity.Value;
        }
        throw new Error(`${this.className}.deg: unknown unit ${this.unit}`);
    }
    clone() {
        return Angle.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case AngleUnits.deg:
                return this.deg;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.Angle = Angle;
Angle.units = Array.from(new Set(Object.values(AngleUnits).map((u) => u)));
//# sourceMappingURL=Angle.js.map